import React from 'react';

// COMPONENT
import SvgMask from '../_Helpers/SvgMask';

// TYPE
export type QuestionState = 'default' | 'success' | 'danger';

interface PaginationDotProps {
	label: number | string;
	state?: QuestionState;
	isActive?: boolean;
	className?: string;
	onClick?: React.MouseEventHandler<HTMLDivElement>;
}

const PaginationDot: React.FC<PaginationDotProps> = ({
	label,
	state = 'default',
	className = '',
	onClick,
	isActive
}) => {
	return (
		<div className={`assessment-pagination-dot ${state} ${isActive ? 'active' : ''}`} onClick={onClick}>
			{state === 'default' && <>{label}</>}

			{state === 'success' && <SvgMask className="status-icon" path={'/svg/tick-success.svg'} width={16} height={16} />}

			{state === 'danger' && <SvgMask className="status-icon" path={'/svg/tick-danger.svg'} width={16} height={16} />}
		</div>
	);
};

export default PaginationDot;
